import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Common Bulletin board(Bulletin board message) Service
 * !== 공통 게시판 (게시글) Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/btbdms`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/sysm/btbdms/btbdms-mgmt`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0106001q: `${BASE.path}/osci0106001q`, // Common Bulletin board(Bulletin board message) List            !== 게시판 관리 목록 ==!
    osci0106002q: `${BASE.path}/osci0106002q`, // Common Bulletin Board(Bulletin board message) Detail          !== 게시판 관리 상세 ==!
    osci0106003s: `${BASE.path}/osci0106003s`, // Common Bulletin Board(Bulletin board message) Registration    !== 게시판 관리 등록 ==!
    osci0106004s: `${BASE.path}/osci0106004s`, // Common Bulletin Board(Bulletin board message) Modification    !== 게시판 관리 수정 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View Bulletin board Management information  !== 게시판 관리 정보 조회 ==!
    getBltbrdInfo: (id: any) => api.get(`${BASE.api}/${id}`),

    // Regist Bulletin board message, Bulletin board Reply  !== 게시글,답글 등록 ==!
    registBtbdmsInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // View a list of Bulletin board Message !== 게시글 목록 조회 ==!
    getBtbdmsList: (data: any, bltbrdId: any, page: number, size: number) => {
        return api.get(`${BASE.api}/list/${bltbrdId}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // View Bulletin board Messasge information (on detailed inquiry screen)  !== 게시글 정보 조회 (상세조회화면에서)==!
    getBtbdmsInfoFromQ: (bltbrdId: any, btbdmsId: any) => api.get(`${BASE.api}/${bltbrdId}/${btbdmsId}?from=Q`),

    // View Bulletin board Messasge information (on detailed inquiry screen)  !== 게시글 정보 조회 (수정화면에서)==!
    getBtbdmsInfoFromS: (bltbrdId: any, btbdmsId: any) => api.get(`${BASE.api}/${bltbrdId}/${btbdmsId}`),

    // Modify Bulletin board message information  !== 게시글 수정 ==!
    modifyBtbdmsInfo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },

    // Delete Bulletin board message information  !== 게시글 삭제 ==!
    deleteBtbdmsInfo: (bltbrdId: any, btbdmsId: any, from: String) => {
        return api.delete(`${BASE.api}/${bltbrdId}/${btbdmsId}?from=${from}`);
    },

    // Regist Bulletin board Comment  !== 댓글 등록 ==!
    registBtbdcmInfo: (data: any) => {
        return api.post(`${BASE.api}/cmnt`, {
            ...data,
        });
    },
    // Delete Bulletin board message information  !== 댓글 삭제 ==!
    deleteBtbdcmInfo: (btbdmsId: any, seq: any) => {
        return api.delete(`${BASE.api}/cmnt/${btbdmsId}/${seq}`);
    },

    // Modify Bulletin board message information  !== 게시글 수정 ==!
    modifyBtbdrpSttsCd: (data: any) => {
        return api.put(`${BASE.api}/stts`, {
            ...data,
        });
    },
};

export const SF_BTBDMS_MGMT_SRCH: TFormSchema = {
    id: "form_btbdmsSrch",
    schema: {
        // regstSrchStrtDt : { required: true, type: "date", label : "L_REGST_STRT_DT" },
        // regstSrchEndDt : { required: true, type: "date", label : "L_REGST_END_DT" },
        btbdmsTtleNm: { type: "text", label: "L_BTBDMS_TTLE_NM" },
        frstRgsrDtmRnge: {
            type: "daterange",
            label: "L_RGSR_PRID",
            start: { name: "regstSrchStrtDt" },
            end: { name: "regstSrchEndDt" },
            rangeButton: 2,
            // controlSize: 10,
        },
        btbdrpSttsCd: { type: "select", label: "L_POST_STTS", area: "comnCd", comnCd: "OSC0162" },
        reffKey: { type: "text", label: "L_REFF_KEY", letterCase: "upper" },
    },
};

const YnOptArr = [
    { label: "Y", value: "Y" },
    { label: "N", value: "N" },
];

export const labelConversionMap = [
    { comnCd: "OSC0158", label: "L_ANOCMT_CTGR" },
    { comnCd: "OSC0163", label: "L_CLR_SUB_CTGR" },
];

export const SF_BTBDMS_MGMT: TFormSchema = {
    id: "form_btbdms",
    schema: {
        bltbrdId: { type: "text", label: "L_BLTBRD_ID" },
        btbdmsId: { type: "text", label: "L_BTBDMS_ID" },
        uprBtbdmsId: { type: "text", label: "L_UPR_BTBDMS_ID" },
        // Keep the template title limit aligned with OSCI_BTBDMS_M.BTBDMS_TTLE_NM.
        btbdmsTtleNm: { required: true, type: "text", label: "L_BTBDMS_TTLE_NM", maxLength: 300 },
        btbdmsCn: { type: "editor", label: "L_BTBDMS_CN", height: 300 },
        btbdmsIntCn: { type: "editor", label: "L_BTBDMS_INT_CN", height: 300 },
        ppupYn: { type: "radio", label: "L_PPUP_YN", options: YnOptArr, defaultValue: "N" },
        reffKey: { type: "text", label: "L_REFF_KEY", edit: false },
        aprvStatCd: { type: "code", label: "L_APRV_STAT_CD", edit: false, area: "comnCd", comnCd: "OSC0096" },
        secrtBtbdmsYn: {
            required: true,
            type: "radio",
            label: "L_SECRT_BTBDMS_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        ppupStrtDtm: {
            required: true,
            type: "datetime",
            label: "L_PPUP_STRT_DTM",
            options: YnOptArr,
            defaultValue: "N",
        },
        ppupEndDtm: { required: true, type: "datetime", label: "L_PPUP_END_DTM", options: YnOptArr, defaultValue: "N" },
        fileGrpUuid: { label: "File", type: "file", multiple: true },
        intFileGrpUuid: { label: "File", type: "file", multiple: true },
        btbdrpSttsCd: {
            type: "select",
            label: "L_POST_STTS",
            options: [],
        },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        frstRgsrDtm: { type: "text", label: "L_FRST_RGSR_DTM" },
    },
};

export const SF_BTBDRP_MGMT: TFormSchema = {
    id: "form_btbdrp",
    schema: {
        bltbrdId: { type: "text", label: "L_BLTBRD_ID" },
        btbdmsId: { type: "text", label: "L_BTBDMS_ID" },
        uprBtbdmsId: { type: "text", label: "L_UPR_BTBDMS_ID" },
        btbdmsTtleNm: { required: true, type: "text", label: "L_RP_BTBDMS_TTLE_NM" },
        btbdrpSttsCd: { required: true, type: "select", label: "L_POST_STTS" },
        btbdmsCn: { type: "editor", label: "L_BTBDMS_CN", height: 300 },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        frstRgsrDtm: { type: "date", label: "L_FRST_RGSR_DTM" },
        replyFileGrpUuid: { label: "File", type: "file", multiple: true },
    },
};

export const SG_BTBDMS_MGMT_LIST_INIT: TGridSchema = {
    id: "grid_btbdmsMgmtinit",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_BTBDMS_TTLE_NM", binding: "btbdmsTtleNm", width: "*" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "*" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "btbdmsTtleNm", align: "left" }] },
        { cells: [{ binding: "frstRegstId" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};
